<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Список центров ответственности
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
          size="20"
          color="info"
          class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
          v-model="search"
          color="info"
          outlined
          label="Начните набирать наименование центра ответствненности"
          class="search-field"
          dense
          style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
        :headers="headers.massive"
        :headers-for-rows="headers.massive"
        :num-cols="headers.countCells"
        :loading-data="loading || getFoundersStatus"
        :data-rows="showingData"
        type-table="grid"
      >
        <template #founder1="{row,cell}">
          <div v-html="cell.template(row)">
          </div>
          <contact-menu :id="row.id" :props-contact="row.contact">
            <template #header-title>
              {{ row.name }}
            </template>
          </contact-menu>
        </template>
        <template #actions="{row}">
          <v-btn class="white__v-btn" @click="authAdOrg(row)">Войти</v-btn>
        </template>
        <template #blocks="{row}">
          <v-btn
            icon
            :disabled="blocking.value"
            :loading="blocking.value && blocking.id === row.id && blocking.stage === 1"
            @click="blockCo(row,1)"
          >
            <v-icon size="24" :color="checkOnBlock(row, 1) ? 'info' : 'success'">
              {{ checkOnBlock(row, 1) ? 'mdi-lock-outline' : 'mdi-lock-open-outline' }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="blocking.value"
            :loading="blocking.value && blocking.id === row.id && blocking.stage === 3"
            @click="blockCo(row, 3)"
          >
            <v-icon size="24" :color="checkOnBlock(row, 3) ? 'info' : 'success'">
              {{ checkOnBlock(row, 3) ? 'mdi-lock-outline' : 'mdi-lock-open-outline' }}
            </v-icon>
          </v-btn>
        </template>
      </grid-table>
    </wrapper-preview-category>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import config from "@/pages/Admin/configs/co_config";
import {mapActions, mapGetters} from "vuex";
import ContactMenu from "@/components/Menus/contact-menu";
import UserController from "@/controllers/UserController";

export default {
  name: "Co",
  components: {ContactMenu, GridTable, WrapperPreviewCategory},
  data() {
    return {
      search: '',
      headers: config,
      loading: false,
      blocking: {value: false, id: null, stage: null},
    }
  },
  computed: {
    ...mapGetters('spr', {
      getFounders: 'getCos',
      getFoundersStatus: 'getFoundersStatus'
    }),
    showingData() {
      return this.getFounders
        .filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1 || String(el.id).toLowerCase().search(this.search.toLowerCase()) !== -1)
        .sort((a, b) => a.id - b.id)
    }
  },
  created() {
    this.getServerData()
  },
  methods: {
    ...mapActions('spr', {getCOsFromServer: 'getCOsFromServer', changeBlockInfo: 'changeBlockInfo'}),
    ...mapActions('keycloak', {initFakeUser: 'initFakeUser'}),
    ...mapActions('checkFilled', {loadingBlockInfo: 'loadingBlockInfo'}),
    checkOnBlock(row, stageId) {
      return row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === stageId) && row.stageDataBlocks.find(el => el.stageId === stageId)?.block === true
    },
    async blockCo(row, stageId) {
      this.blocking.value = true;
      this.blocking.id = row.id;
      this.blocking.stage = stageId;
      if (row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === stageId) && row.stageDataBlocks.find(el => el.stageId === stageId)?.block === true)
        await UserController.unBlock('founder', stageId, row.id)
          .finally(() => {
            this.blocking.value = false;
            this.blocking.id = null;
            this.blocking.stage = null;
          });
      else
        await UserController.setBlock('founder', stageId, row.id)
          .finally(() => {
            this.blocking.value = false;
            this.blocking.id = null;
            this.blocking.stage = null;
          });
    },
    async getServerData() {
      try {
        this.loading = true;
        await this.getCOsFromServer();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    authAdOrg(row) {
      // console.log(row)
      this.initFakeUser({
        role: 'CO_ROLE',
        id: row.id,
        name: row?.name ?? ''
      });
      this.loadingBlockInfo();
      this.$router.push({name: 'stage-3'})
    }
  },
}
</script>

<style scoped>

</style>